import React from 'react';

const SettingsForm = ({ onSubmit, children }) => (
  <form className="settings-form" onSubmit={onSubmit} style={{ width: '100%' }}>
    {children}
  </form>
);

export default SettingsForm;
